import { render } from "./EmployeeDeniedPrs.vue?vue&type=template&id=0456ebda"
import script from "./EmployeeDeniedPrs.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedPrs.vue?vue&type=script&lang=js"

import "./EmployeeDeniedPrs.vue?vue&type=style&index=0&id=0456ebda&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__